import { Breadcrumb, Col, Layout, Row, Typography } from "antd";
import { usePathname } from "../../../shared/usePathname";
import { privatePagesMap } from "../router/privatePagesMap";

const getBreadcrumbItems = (subpaths) => {
  const items = [];
  for (var i = 0; i < Math.min(subpaths.length, 2); i++) {
    const item = privatePagesMap[subpaths[i]];
    items.push({
      title: (
        <>
          {item.icon != null && item.icon}
          <span>{item.label ?? item.name}</span>
        </>
      ),
    });
  }
  return items;
};

const SubHeader = () => {
  const { subpaths } = usePathname();
  const [first, second] = subpaths;
  const currentPage = second ? first + second : first;
  const lastPage = second ?? first;

  const pageName =
    privatePagesMap[currentPage]?.name ??
    privatePagesMap[lastPage]?.name ??
    privatePagesMap[currentPage]?.label ??
    privatePagesMap[lastPage]?.label ??
    "Not Found";

  return (
    <Layout.Header className="body-header">
      <>
        <Row>
          <Col>
            <Breadcrumb
              style={{ marginTop: 16 }}
              items={getBreadcrumbItems(subpaths)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Typography>
              <Typography.Title
                level={4}
                style={{ marginTop: 16, marginBottom: 16 }}
              >
                {pageName}
              </Typography.Title>
            </Typography>
          </Col>
        </Row>
      </>
    </Layout.Header>
  );
};

export default SubHeader;
